import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import MyAccountAppointmentPage from './MyAccountAppointmentPage.js';

export default WithGASetup(MyAccountAppointmentPage, AuthContext);
